import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import { FormField } from '../form-field/form-field';
import { FormFieldError } from './form-field-error';
import { TObject } from '../../../../infrastructure/type-extensions';
import { CopyButton } from '../../copy-button/copy-button';
import { FormFieldProps } from '../../../../infrastructure/form-viewmodel-controller';
import { REQUIRED_FIELD_TEXT } from '../../../../constants/common-labels.constants';

interface InputProps {
    field: FormFieldProps;
    inputType?: string;
    disabled?: boolean;
    readOnly?: boolean;
    placeholder?: string;
}
interface IProps extends InputProps {
    labelDescriptor: MessageDescriptor;
    withError?: boolean;
    fieldMessageValues?: TObject<string>;
    withCopyBtn?: boolean;
    additionalClassName?: string;
    withoutIcon?: boolean;
    onCopy?: () => void;
    required?: boolean;
    placeholder?: string;
}

const Input = ({ field, inputType, disabled, readOnly, placeholder }: InputProps): JSX.Element => (
    <input
        className='oe-form-field__control'
        value={field.value as string | number | string[]}
        type={inputType}
        onChange={e => field.setValue(e.target.value)}
        onBlur={field.setTouched}
        disabled={disabled}
        readOnly={readOnly}
        placeholder={placeholder}
    />
);

export const FormFieldInputText = observer(({
    field, labelDescriptor, inputType = 'text', fieldMessageValues, withError, withCopyBtn, additionalClassName,
    disabled, readOnly, withoutIcon, onCopy, required, placeholder
}: IProps): JSX.Element => {
    return (
        <FormField
            className={`m-bottom-20px ${additionalClassName || ''}`}
            label={<>
                <FormattedMessage values={fieldMessageValues} {...labelDescriptor} />
                {required && <span className='oe-form-field__title-required'><FormattedMessage {...REQUIRED_FIELD_TEXT} /></span>}
            </>}
        >
            {
                withCopyBtn
                    ? (
                        <div className='flex'>
                            <Input field={field} inputType={inputType} disabled={disabled} readOnly={readOnly} />
                            <CopyButton onCopy={onCopy} withoutIcon={withoutIcon} copyValue={field.value} className='m-left-10px' disabled={!field.value} />
                        </div>
                    )
                    : <Input field={field} inputType={inputType} disabled={disabled} readOnly={readOnly} placeholder={placeholder} />
            }
            {withError && <FormFieldError field={field} labelDescriptor={labelDescriptor} />}
        </FormField>
    );
});
